module.exports = __webpack_public_path__ + "img/theme-custom.946c21aa.png";